
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenant]",
      function () {
        return require("private-next-pages/[tenant]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenant]"])
      });
    }
  